import { BUYER_ANALYTICS_EVENTS } from "../../constants/automapAnalyticsEvents";
import { trackBuyerEvent } from "../buyerAnalytics";
import { toListingAnalyticsPayload } from "../automapListing/listingViewModels";

export function trackVehicleLikeEvent(eventType, listing, extra = {}) {
  if (!listing) return;
  trackBuyerEvent(
    eventType,
    toListingAnalyticsPayload(listing, {
      sourceComponent: extra.sourceComponent || "vehicle_like_button",
      ...extra,
    })
  );
}

export function trackVehicleSaved(listing, extra = {}) {
  trackVehicleLikeEvent(BUYER_ANALYTICS_EVENTS.VEHICLE_SAVED, listing, extra);
}

export function trackVehicleUnsaved(listing, extra = {}) {
  trackVehicleLikeEvent(BUYER_ANALYTICS_EVENTS.VEHICLE_UNSAVED, listing, extra);
}
